<app-site-settings-menu>
    <div class="navigation-menu-list main-container">
        <div class="menu">
            <mat-list>
                <ng-container *ngFor="let item of navList">
                    <mat-list-item 
                        appLocalizationPopupDirective 
                        [localizationCode]="item.text"
                        setColor
                        [setColorRules]="[
                            {
                                color: 'primaryColour',
                                events: ['hover']
                            },
                            {
                                color: 'primaryColour',
                                setIfClass: ['primaryColor'],
                                events: ['routerLinkActive']
                            },
                        ]"
                        [routerLink]="item.link" 
                        routerLinkActive="primaryColor" 
                        class="primaryHoverColor" 
                        *appHasFeature="item.featureCode"
                    >
                        <mat-icon 
                            setColor
                            [setColorRules]="[
                                {
                                    color: 'primaryColour',
                                    events: ['hover']
                                },
                                {
                                    color: 'primaryColour',
                                    setIfClass: ['primaryColor'],
                                    events: ['routerLinkActive']
                                },
                            ]"
                            routerLinkActive="primaryColor"
                            class="material-icons-outlined"
                        >{{item.icon}}</mat-icon>
                        <div class="text">{{ translate.instant(item.text) }}</div>
                    </mat-list-item>
                </ng-container>
            </mat-list>
        </div>
        <div class="content">
            <ng-content></ng-content>
        </div>
    </div>
</app-site-settings-menu>